import React from 'react';
import styled from 'styled-components';
import { PublicPageLayout } from '../components/PublicPageLayout';

const Section = styled.section`
  background: var(--bg-card);
  border: 1px solid rgba(0, 212, 170, 0.12);
  border-radius: 18px;
  padding: 28px;
  margin-bottom: 20px;
  box-shadow: 0 20px 40px rgba(15, 23, 42, 0.2);
`;

const SectionTitle = styled.h2`
  font-size: 1.2rem;
  margin-bottom: 10px;
`;

const Paragraph = styled.p`
  color: var(--text-muted);
  margin-bottom: 12px;
`;

const List = styled.ul`
  padding-left: 20px;
  color: var(--text-muted);
`;

export const PrivacyPage: React.FC = () => {
  return (
    <PublicPageLayout
      title="Politica de Privacidade"
      subtitle="Seu negocio seguro, seus dados protegidos."
      eyebrow="Transparencia"
    >
      <Section>
        <SectionTitle>1. Dados coletados</SectionTitle>
        <Paragraph>
          Coletamos dados necessarios para operacao do sistema, incluindo informacoes de cadastro,
          dados de contato, atividade dentro da plataforma e informacoes de faturamento.
        </Paragraph>
        <List>
          <li>Dados pessoais: nome, email, telefone e CNPJ/CPF.</li>
          <li>Dados de uso: acessos, recursos utilizados e configuracoes.</li>
          <li>Dados financeiros: status de pagamento e historico de faturas.</li>
        </List>
      </Section>

      <Section>
        <SectionTitle>2. Uso das informacoes</SectionTitle>
        <Paragraph>
          Utilizamos seus dados para oferecer a melhor experiencia, cumprir obrigacoes legais
          e melhorar nossos servicos.
        </Paragraph>
        <List>
          <li>Operar o sistema e suporte ao cliente.</li>
          <li>Enviar comunicacoes relevantes (ex: avisos de pagamento).</li>
          <li>Gerar relatorios internos e analises de performance.</li>
        </List>
      </Section>

      <Section>
        <SectionTitle>3. Compartilhamento</SectionTitle>
        <Paragraph>
          Nao vendemos dados. Compartilhamos apenas com parceiros essenciais para operacao,
          como provedores de pagamento e email.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>4. Armazenamento e seguranca</SectionTitle>
        <Paragraph>
          Mantemos medidas de seguranca tecnicas e organizacionais para proteger suas informacoes.
        </Paragraph>
        <List>
          <li>Criptografia em transito sempre que possivel.</li>
          <li>Controle de acesso interno.</li>
          <li>Backups e monitoramento continuo.</li>
        </List>
      </Section>

      <Section>
        <SectionTitle>5. Cookies e rastreamento</SectionTitle>
        <Paragraph>
          Utilizamos cookies essenciais para autenticacao e funcionamento. Cookies de analise
          podem ser usados para melhorar a plataforma.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>6. Direitos do titular</SectionTitle>
        <Paragraph>
          Voce pode solicitar acesso, correcao ou exclusao de dados conforme a legislacao vigente.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>7. Contato e DPO</SectionTitle>
        <Paragraph>
          Para duvidas sobre privacidade, use nossa pagina de contato. Atenderemos sua solicitacao
          dentro dos prazos legais.
        </Paragraph>
      </Section>
    </PublicPageLayout>
  );
};
